/* unplugin-vue-components disabled */import script from "./RoomConfigure.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomConfigure.vue?vue&type=script&setup=true&lang=js"

import "./RoomConfigure.vue?vue&type=style&index=0&id=38ba8e4e&lang=scss"
import "./RoomConfigure.vue?vue&type=style&index=1&id=38ba8e4e&lang=scss&scoped=true"
import "./RoomConfigure.vue?vue&type=style&index=2&id=38ba8e4e&lang=scss"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ba8e4e"]])

export default __exports__